<template>
    <div class="overflow-auto">
        <b-container fluid class="bv-example-row">
            <b-row>
                <b-col>
                    <span class="text-nowrap">
                        {{$t('devices_selected')+ ': ' + pagination.rows}}
                    </span></b-col>
                <b-col cols="5">
                    <b-pagination
                            :disabled="isBusy"
                            v-model="pagination.currentPage"
                            :total-rows="pagination.rows"
                            :per-page="perPage"
                            aria-controls="my-table"
                            limit="7"
                    >
                    </b-pagination>
                </b-col>
                <b-col>
                    <b-button
                        @click="clearFilter"
                        variant="info"
                        size="sm"

                        class="float-right"
                    >
                      <span class="text-nowrap" style="font-size: 130%">
                      {{$t('device_list.clear_filter')}}
                      </span>
                    </b-button>
                </b-col>
                <b-col>
                    <b-button
                        @click="$bvModal.show ('bv-modal-device-table-settings')"
                        variant="primary"
                        size="sm"
                        class="float-right"

                    >
                      <span class="text-nowrap" style="font-size: 130%">
                      {{$t('device_list.settings')}}
                      </span>
                    </b-button>
                    <!--                    <b-button-->
                    <!--                        class="p-0"-->
                    <!--                        style="width: 180px"-->
                    <!--                        to="devicesGroupActions"-->
                    <!--                        variant="primary"-->
                    <!--                        size="sm"-->
                    <!--                    >-->
                    <!--                        <span class="text-nowrap" style="font-size: 130%">-->
                    <!--                          {{$t('group_management')}}-->
                    <!--                        </span>-->
                    <!--                    </b-button>-->
                    <b-modal
                        id="bv-modal-device-table-settings"
                        header-bg-variant="dark"
                        header-text-variant="light"
                        body-bg-variant="dark"
                        body-text-variant="light"
                        hide-footer
                        size="lg"
                    >
                        <template v-slot:modal-title>
                            {{$t('device_list.settings')}}
                        </template>
                        <b-form @submit="updateFieldsAndRefreshTable">
                            <DeviceListTableSettings/>
                            <b-button block variant="primary" type="submit" @click="$bvModal.hide('bv-modal-device-table-settings')">Ок</b-button>
                        </b-form>
                    </b-modal>
                </b-col>
            </b-row>
        </b-container>
        <div class="card-body d-block d-md-none">
            <h5 class="card-title">{{$t('device_list.filter')}}</h5>
            <b-form-group
                label-for="filter_id"
                :label="$t('device_list.coll.header.id')"
            >
                <b-input
                    id="filter_id"
                    v-model="filters.customId"
                    :placeholder="$t('device_list.coll.header.id')"
                    value-field="id"
                    text-field="name"
                />
            </b-form-group>
            <b-form-group
                label-for="filter_imei"
                :label="$t('device_list.coll.header.imei')"
            >
                <b-input
                    id="filter_imei"
                    v-model="filters.imei"
                    :placeholder="$t('device_list.coll.header.imei')"
                    value-field="id"
                    text-field="name"
                />
            </b-form-group>
        </div>
        <b-table dark
                :busy.sync="isBusy"
                ref="table"
                id="device-list"
                :items="myProvider"
                :per-page="perPage"
                :current-page="pagination.currentPage"
                :hover="hover"
                head-variant="dark"
                small
                :fields="fields"
                no-local-sorting
                :filter="filterListTable"
                :filterIncludedFields="filterOn"
                stacked="md"
                :filter-function="onFilter"
                striped
                :sort-by.sync="sorting.sortBy"
                :sort-desc.sync="sorting.sortDesc"
                primary-key="id"
                @refreshed="selectSelected"
                @context-changed="selectSelected"
        >
            <template v-slot:head()="scope">

                <div class="text-nowrap">
                    {{  $t(scope.label) }}
                </div>
            </template>

            <template v-slot:head(selected)>
                    <b-checkbox
                            style="width: 30px"
                            v-model="checkedAll"
                    ></b-checkbox>
            </template>

            <template v-slot:head(settings)="scope">
                <icon-base
                        icon-color="green"
                        icon-name="settings-head"
                        v-b-tooltip.hover
                        :title="$t(scope.label)"
                ><settings-icon />
                </icon-base>
            </template>
            <template v-slot:cell(customId)="row">
                <b-row class="ml-1">
                {{row.item.customId }}
                    <b-button
                        variant="link"
                        style="color: white;"
                    >
                <b-icon-files
                    v-b-tooltip.hover
                    :title="$t('device_list.coll.id.copy')"
                    @click="doCopy(row.item.customId)"
                    size="sm"
                ></b-icon-files>
                    </b-button>
                </b-row>
            </template>
            <template v-slot:cell(imei)="row">
                <b-row class="ml-1">
                {{row.item.imei }}
                    <b-button
                        variant="link"
                        style="color: white;"
                        size="sm"
                    >
                <b-icon-files
                    v-b-tooltip.hover
                    :title="$t('device_list.coll.imei.copy')"
                    @click="doCopy(row.item.imei)"
                ></b-icon-files>
                    </b-button>
                </b-row>
            </template>

            <template v-slot:cell(selected)="{ rowSelected }">
                <b-checkbox
                        :checked="rowSelected"
                        style="width: 30px"
                ></b-checkbox>
            </template>
            <template v-slot:cell(settings)="row">
                <router-link
                        style="width: 30px"
                        :to="{ name: 'device', params: { id: row.item.id }}"
                >
                    <icon-base
                            icon-name="settings"
                            v-b-tooltip.hover
                            :title="$t('device_list.coll.header.settings')"
                    ><settings-icon />
                    </icon-base>
                </router-link>
            </template>
            <template v-slot:cell(firmwareCurrent)="row">
                <b-row  class="ml-1">
                <div v-if="row.item.isFirmwareActual">
                    {{row.item.firmwareCurrent}}
                </div>
                <div v-else>
                    <span style="color: #dc3545">{{row.item.firmwareCurrent}}  >></span> <span style="color: #28a745">{{row.item.firmwareUpdate}}</span> ({{row.item.firmwareLoadPercent}}%)
                </div>

                <router-link
                    class="ml-1"
                    style="width: 30px"
                    :to="{ name: 'deviceSection', params: { id: row.item.id, section: 'firmware' }}"
                >
                    <b-icon-pencil-square
                        v-b-tooltip.hover
                        :title="$t('device_list.coll.firmware.edit')"
                    ><settings-icon /></b-icon-pencil-square>
                </router-link>
                </b-row>
            </template>
            <template v-slot:cell(lastContactName)="row">
                {{$t('command_type.'+row.item.lastContactName)}}
            </template>
            <template v-slot:cell(status)="row">
              <icon-base
                  :icon-color="row.item.isSettingsActual ? 'green': 'red'"
                  icon-name="status-settings"
                  v-b-tooltip.hover
                  :title="row.item.isSettingsActual ? $t('settings_are_actual'): $t('settings_are_not_actual')"
              ><status-settings-icon /></icon-base>
                <icon-base
                        :icon-color="row.item.isFirmwareActual ? 'green': 'red'"
                        icon-name="status-firmware"
                        v-b-tooltip.hover
                        :title="row.item.isFirmwareActual ? $t('firmware_is_actual'): $t('firmware_is_not_actual')"
                ><status-firmware-icon /></icon-base>
            </template>
            <template v-slot:cell(distributor)="row">
                <b-row  class="ml-1">
                <div class="text-nowrap overflow-hidden" style="width: 100px; text-overflow: ellipsis;">
                    {{ row.item.distributor }}
                </div>
                <router-link
                    class="ml-1"
                    style="width: 30px"
                    :to="{ name: 'deviceCustomIdOrImeiList', params: { customIdOrImeiListRaw: row.item.imei}}"
                >
                    <b-icon-pencil-square
                        v-b-tooltip.hover
                        :title="$t('device_list.coll.organisation.edit')"
                    ><settings-icon /></b-icon-pencil-square>
                </router-link>
                </b-row>
            </template>
            <template slot="thead-top" slot-scope="{ fields }">
                <td v-for="field in fields" :key="field.key">
                    <div v-if="field.filteredType === 'select'">
                        <b-form-select
                            :disabled="isBusy"
                                v-if="field.filtered === true"
                                v-model="filters[field.key]"
                                :style="{width: field.width + 'px'}"

                                :options="getDictionary(field.dictionaryName)"
                                value-field="id"
                                text-field="name"
                        />

                    </div>
                    <div v-else>
                        <b-input
                                v-if="field.filtered === true"
                                v-model="filters[field.key]"
                                :placeholder="$t(field.label)"
                                :style="{width: field.width + 'px'}"
                                :min="field.min"
                                :max="field.max"
                        />
                    </div>
                </td>
            </template>
        </b-table>
    </div>
</template>

<script>
    import axios from 'axios';

    import {RequestGuard} from '../../utils/RequestGuard';
    import {watchPageVisibility} from '../../utils/PageVisibility';
    import DeviceListTableSettings from './DeviceListTableSettings'
    import IconBase from "./../../components/Icons/IconBase18.vue";
    import SettingsIcon from "./../../components/Icons/icons/Settings.vue";
    import StatusFirmwareIcon from "./../../components/Icons/icons/StatusFirmware.vue";
    import StatusSettingsIcon from "./../../components/Icons/icons/StatusSettings.vue";

    export default {
        name: "DeviceList",
        components: {
            DeviceListTableSettings,
            IconBase,
            SettingsIcon,
            StatusFirmwareIcon,
            StatusSettingsIcon,
        },
        data() {
            return {
                checkedAll: false,
                isDragging: false,
                filter: null,
                filterOn: [],
                isBusy: false,
                perPage: Math.max(1, Math.floor(document.documentElement.clientHeight / 48)),
                deviceTypeList: [],
                fields: [],
                // items: [ ],
                small: true,
                bordered: true,
                hover: true,
                pagination: {
                    currentPage: 1,
                    rows: 0,
                },
                sorting: {
                    sortBy: 'customId',
                    sortDesc: true,
                },
                filters: {
                    id: null,
                    imei: null,
                    customId: null,
                    distributor: null,
                    distributorIdentity: null,
                    type: null,
                    sim1: null,
                    sim2: null,
                    trafficModel: null,
                    registeredNumber: null,
                    object: null,
                    description: null,
                },
                filterListTable: {
                    id: null,
                    imei: null,
                    customId: null,
                    distributor: null,
                    distributorIdentity: null,
                    type: null,
                    sim1: null,
                    sim2: null,
                    trafficModel: null,
                    registeredNumber: null,
                    object: null,
                    description: null,
                },
                breadcrumb: [
                    {
                        text: 'Admin',
                        href: '#'
                    },
                    {
                        text: 'Manage',
                        href: '#'
                    },
                    {
                        text: 'Library',
                        active: true
                    }
                ],
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    content: ''
                },
                selected: [],
                timer: null,
                delayTimer: null,
                selectionTimer: null,
                pollingActive: true,
                providerRequests: new RequestGuard(),
                providerPromise: null,
                providerKey: null,
                typeRequests: new RequestGuard(),
                typesLoaded: false,
                stopWatchingVisibility: null,
                copyText: null
            }
        },

        computed: {
            availableColumns: {
                get() {
                    return this.$store.state.deviceListTableFields;
                },
            }
        },
        watch: {
            checkedAll: function(val) {
                if (val === true) {
                    this.selectAllRows();
                    return;
                }

                this.clearSelected();
            },
            filters: {
                handler(){
                    clearTimeout(this.delayTimer);
                    this.delayTimer = null;
                    if (!this.pollingActive || document.hidden) {
                        return;
                    }

                    this.delayTimer = setTimeout(this.setTableFilter, 2000);

                },
                deep: true
            }
        },
        methods: {
            startUpdate() {
                if (this.pollingActive && !document.hidden && this.timer === null) {
                    this.timer = setInterval(this.onUpdate, 30000);
                }
            },
            stopUpdate(deactivate = true) {
                if (deactivate) {
                    this.pollingActive = false;
                }
                this.providerRequests.invalidate();
                this.typeRequests.invalidate();
                this.providerPromise = null;
                this.providerKey = null;
                this.isBusy = false;
                clearInterval(this.timer);
                clearTimeout(this.delayTimer);
                clearTimeout(this.selectionTimer);
                this.timer = null;
                this.delayTimer = null;
                this.selectionTimer = null;
            },
            onPageVisibilityChanged() {
                if (document.hidden) {
                    this.stopUpdate(false);
                } else {
                    this.resumeVisiblePolling();
                }
            },
            resumeVisiblePolling() {
                if (this.pollingActive && !document.hidden) {
                    this.setTableFilter();
                    this.loadDeviceTypes();
                    this.startUpdate();
                    this.onUpdate();
                }
            },
            doCopy: function (item) {
                this.$copyText(item).then(function () {
                }, function (e) {
                    alert('Can not copy')
                    console.log(e)
                })
            },
            setTableFilter: function() {
                for (let field in this.filters) {
                    this.filterListTable[field] = this.filters[field]
                }
            },
            getDictionary: function(type) {
                if (type=== 'deviceType') {
                    return this.deviceTypeList
                }

                return []
            },
            onFilter: function() {
                // alert(11);
              // console.log('onFilter');
            },
            onRowSelected(items) {
                this.selected.forEach(
                    (item) => {this.selected[item] = false;}
                )

                items.forEach(
                    item => {
                        this.selected[item.id] = true;
                    }
                )

              // console.log(this.selected)
            },
            selectSelected() {
                if (!this.pollingActive || document.hidden) {
                    return;
                }
                // console.log('select');
                // console.log(this.$refs.table);
                // console.log(this.$refs.table.renderBusy());
                // console.log(this.$refs.table.busy);

                let t = this.$refs.table;
                let s = [];

                this.selected.forEach(
                    (value, index) => {
                        s[index] = value;
                    }
                )

                clearTimeout(this.selectionTimer);
                this.selectionTimer = setTimeout(function(){
                    t.localItems.forEach(
                        (value, index) => {
                            if (s[value.id] === true) {
                                t.selectRow(index)
                            }
                        }
                    )
                }, 100);

            },
            selectAllRows() {
                this.$refs.table.selectAllRows()
            },
            clearSelected() {
                this.$refs.table.clearSelected()
            },
            info(item, index, button) {
                this.infoModal.title = `Row index: ${index}`
                this.infoModal.content = JSON.stringify(item, null, 2)
                this.$root.$emit('bv::show::modal', this.infoModal.id, button)
            },
            clearFilter() {
                for (let filter in this.filters) {
                    this.filters[filter] = null;
                }
            },
            myProvider (ctx) {
                if (!this.pollingActive || document.hidden) {
                    return Promise.resolve([]);
                }
                // console.log(ctx)
                // Here we don't set isBusy prop, so busy state will be
                // handled by table itself

                let param = {
                    'page': ctx.currentPage,
                    'rows':  ctx.perPage,
                    'sortBy':  ctx.sortBy,
                    'sortOrder':  (ctx.sortDesc ? 'desc': 'asc'),
                    }
                ;

                for (let field in this.filters) {
                    if (this.filters[field] !== null) {

                        param[field] = this.filters[field]

                    }
                }

                const key = JSON.stringify(param);
                if (this.providerPromise && this.providerKey === key) {
                    return this.providerPromise;
                }
                this.providerRequests.invalidate();
                const request = this.providerRequests.begin();
                this.providerKey = key;
                const isCurrent = () => this.pollingActive && !document.hidden && this.providerRequests.isCurrent(request);
                const savedFilters = JSON.stringify(this.filters);
                const savedSorting = JSON.stringify(this.sorting);
                this.isBusy = true
                let promise = axios.get('api/v1/devices',  { params: param, ...this.providerRequests.config(request) })

                this.providerPromise = promise.then((data) => {
                    if (!isCurrent()) {
                        return [];
                    }
                    const items = data.data.data
                    // Here we could override the busy state, setting isBusy to false
                    this.pagination.rows = data.data.records

                    //set page 0 i
                    if (this.pagination.currentPage > 1 && items.length  === 0) {
                        this.pagination.currentPage = 1;
                    }

                    this.isBusy = false

                    localStorage.setItem('deviceListFilters', savedFilters);
                    localStorage.setItem('deviceListPagination', JSON.stringify(this.pagination));
                    localStorage.setItem('deviceListSorting', savedSorting);

                    return(items)
                }).catch(error => {
                    if (!isCurrent()) {
                        return [];
                    }
                    this.$emit('load-error', error);
                    // Here we could override the busy state, setting isBusy to false
                    // this.isBusy = false
                    // Returning an empty array, allows table to correctly handle
                    // internal busy state in case of error
                    // console.log(error)
                    return []
                }).finally(() => {
                    if (isCurrent()) {
                        this.isBusy = false;
                        this.providerPromise = null;
                        this.providerRequests.finish(request);
                    }
                });
                return this.providerPromise;
            },
            onUpdate() {
                if (this.pollingActive && !document.hidden && !this.isBusy && this.$refs.table !== undefined) {
                    this.$refs.table.refresh();
                }
            },
            updateFields() {
                let index = 0;

                this.fields = [];
                this.availableColumns.forEach(
                    column => {
                        column.order = ++index;
                        if (column.visible === true) {
                            column.label = this.$t(column.label_t)

                            this.fields.push(column);
                        }
                    }
                )
            },
            loadDeviceTypes() {
                if (!this.pollingActive || document.hidden || this.typesLoaded) {
                    return;
                }
                const request = this.typeRequests.begin();
                if (request === null) {
                    return;
                }
                const isCurrent = () => this.pollingActive && !document.hidden && this.typeRequests.isCurrent(request);
                axios.get('api/v1/devices/device-types', this.typeRequests.config(request))
                    .then(data => {
                        if (isCurrent()) {
                            this.deviceTypeList = [{ id: null, name: this.$t('select_type'), selected: true }].concat(data.data.rows);
                            this.typesLoaded = true;
                        }
                    })
                    .catch(error => {
                        if (isCurrent()) {
                            this.$emit('load-error', error);
                        }
                    })
                    .finally(() => this.typeRequests.finish(request));
            },
            updateFieldsAndRefreshTable() {
                this.updateFields();
                if (this.$refs.table !== undefined) {
                    this.$refs.table.refresh();
                }

                let localSettings = {};

                this.availableColumns.forEach(
                    column => {
                        localSettings[column.key] = column;
                    }
                )

                localStorage.setItem('deviceListSettings', JSON.stringify(localSettings));
            }
        },
        mounted() {


            let localSettings = {};

            if (localStorage.getItem('deviceListSettings')) {
                try {
                    localSettings = JSON.parse(localStorage.getItem('deviceListSettings'));
                } catch(e) {
                    localStorage.removeItem('deviceListSettings');
                }
            }

            if (localStorage.getItem('deviceListFilters')) {
                try {
                    const filtes = JSON.parse(localStorage.getItem('deviceListFilters'));

                    for (let field in filtes) {
                        this.filters[field] = filtes[field]
                    }

                } catch(e) {
                    localStorage.removeItem('deviceListFilters');
                }
            }

            if (localStorage.getItem('deviceListPagination')) {
                try {
                    this.pagination = JSON.parse(localStorage.getItem('deviceListPagination'));
                } catch(e) {
                    localStorage.removeItem('deviceListPagination');
                }
            }

            if (localStorage.getItem('deviceListSorting')) {
                try {
                    this.sorting = JSON.parse(localStorage.getItem('deviceListSorting'));

                } catch(e) {
                    localStorage.removeItem('deviceListSorting');
                }
            }

            this.updateFields();

            this.availableColumns.forEach(
                column => {
                    if (localSettings[column.key] !== undefined) {
                        if (localSettings[column.key].visible !== undefined) {
                            column.visible = localSettings[column.key].visible;
                        }
                    }
                }
            )

            this.updateFields();

            this.loadDeviceTypes();
        },
        created() {
            this.stopWatchingVisibility = watchPageVisibility(this.onPageVisibilityChanged);
            this.startUpdate();
        },
        beforeDestroy() {
            this.stopWatchingVisibility();
            this.stopUpdate();
        },
        deactivated() {
            this.stopUpdate();
        },
        activated() {
            if (!this.pollingActive) {
                this.pollingActive = true;
                this.resumeVisiblePolling();
            }
        },
    }
</script>

<style scoped>

</style>
